import React, { useEffect, useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import TagsView from "./components/TagsView/TagsView";
import CircleIcon from '@mui/icons-material/Circle';
import { Dialog } from "@mui/material";
import PendingIcon from '@mui/icons-material/Pending';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { styled } from "@mui/material/styles";
import UploadModal from "../../../../components/Modals/UploadModal/UploadModal";
import { useTheme } from "@mui/styles";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from "react-router-dom";
import { GridToolbar } from '@mui/x-data-grid';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CircularProgress from "@mui/material/CircularProgress";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { setViewingLead } from "../../../../slices/viewingLeadSlice";
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import RepositoryControls from "./components/RepositoryControls";
import { StripedDataGrid } from "../../../../componentThemes";
import MortgageActionsModal from "../../../../components/Modals/MortgageActions/MortgageActionsModal";
import { setViewingReports } from "../../../../slices/teamReportsSlice";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import handleFilterMortgages from "./utils/handleFilterMortgages";
import { selectUserFullName } from "../../../../slices/userInfoSlice";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { setViewingMortgage } from "../../../../slices/viewingMortgageSlice";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { removeLeadNotification } from "../../../../slices/userNotificationsSlice";
import { useSelector, useDispatch } from "react-redux";
import { addCustomTagView, editCustomTagView, removeCustomTagView, selectCustomTagViewAdded, selectTagsViewMortgages } from "../../../../slices/teamStatsSlice";
import { removeNotificationFromMortgage, selectMortgagesFilteredBoolean, selectTeamMortgages, setFilteredMortgages, setFwdBckViewingFilteredMortgages, setFwdBckViewingMortgages, setMortgagesFilteredBoolean } from "../../../../slices/teamMortgagesSlice";
import { removeNotificationFromLead, selectTeamAwaitingActionLeads, selectTeamAwaitingUpdateLeads, selectTeamClosingLeads, selectTeamInvestigatingLeads, setFwdBckFilteredViewingLeads, setFwdBckViewingLeads } from "../../../../slices/teamActiveLeadsSlice";
import { selectDashPerspective, selectLeadsFilteredBoolean, selectRepositoryPage, selectRepositoryPageSize, selectRunningSweep, selectShowMortgagectionsModal, selectViewingMortgageActions, selectViewingUploadWindow, setMortgageActionNavMenuSelection, setRepositoryPage, setRepositoryPageSize, setShowMortgageActionsModal, setViewingMortgageActions, setViewingUploadWindow } from "../../../../slices/sessionDataSlice";
import { setViewingFromSearchBool } from "../../../../slices/viewingSearchResultsSlice";

const MortgageRepository = ({ userId, teamId }) => {
  const theme = useTheme()
  const navigate = useNavigate()  
  const dispatch = useDispatch()

  const pageSize = useSelector(selectRepositoryPageSize)
  const userFullName = useSelector(selectUserFullName)
  const closingLeads = useSelector(selectTeamClosingLeads)
  const runningSweep = useSelector(selectRunningSweep)
  const teamMortgages = useSelector(selectTeamMortgages)
  const currentPageSize = useSelector(selectRepositoryPage)
  const dashPerspective = useSelector(selectDashPerspective)
  const showUploadModal = useSelector(selectViewingUploadWindow)
  const tagsViewMortgages = useSelector(selectTagsViewMortgages)
  const investigatingLeads = useSelector(selectTeamInvestigatingLeads)
  const customTagViewAdded = useSelector(selectCustomTagViewAdded)
  const awaitingActionLeads = useSelector(selectTeamAwaitingActionLeads)
  const awaitingUpdateLeads = useSelector(selectTeamAwaitingUpdateLeads)
  const leadsFilteredBoolean = useSelector(selectLeadsFilteredBoolean)
  const viewingMortgageActions = useSelector(selectViewingMortgageActions)
  const showMortgageActionsModal = useSelector(selectShowMortgagectionsModal)
  const mortgagesFilteredBoolean = useSelector(selectMortgagesFilteredBoolean)

  const [userFilter, setUserFilter] = useState('team')
  const [mortgageRows, setMortgageRows] = useState(teamMortgages ? teamMortgages : [])

  const handleOpenActionModal = (mortgage, destination) => {
    dispatch( setViewingReports(mortgage.reports) )
    if (mortgage.activeLead) {
      let thisLead = {}
      thisLead = awaitingActionLeads.find(lead => lead._id === mortgage.activeLead.toString())
      if (!thisLead) {
        thisLead = investigatingLeads.find(lead => lead._id === mortgage.activeLead.toString())
        if (!thisLead) {
          thisLead = closingLeads.find(lead => lead._id === mortgage.activeLead.toString())
          if (!thisLead) {
            thisLead = awaitingUpdateLeads.find(lead => lead._id === mortgage.activeLead.toString())
          }
        }
      }
      if (leadsFilteredBoolean || dashPerspective !== 'team') {
        dispatch( setFwdBckFilteredViewingLeads(thisLead._id) )
      } else {
        dispatch( setFwdBckViewingLeads(thisLead._id) )
      }
      dispatch( setViewingLead(thisLead) )
      if (thisLead.notifCount && thisLead.notifCount > 0) {
        if (thisLead.status === 'awaitingAction') {
          dispatch( removeLeadNotification({status: 'awaitingAction', count: 1}) )
          dispatch( removeNotificationFromLead({status: 'awaitingAction', leadId: thisLead._id}) )
        } else if (thisLead.status === 'investigating') {
          dispatch( removeLeadNotification({status: 'investigating', count: 1}) )
          dispatch( removeNotificationFromLead({status: 'investigating', leadId: thisLead._id}) )
        } else if (thisLead.status === 'closing') {
          dispatch( removeLeadNotification({status: 'closing', count: 1}) )
          dispatch( removeNotificationFromLead({status: 'closing', leadId: thisLead._id}) )
        } else {
          dispatch( removeLeadNotification({status: 'awaitingUpdates', count: 1}) )
          dispatch( removeNotificationFromLead({status: 'awaitingUpdates', leadId: thisLead._id}) )
        }
      }
    } else {
      dispatch( setViewingLead(null) )
      dispatch( setFwdBckViewingLeads(null) )
      dispatch( setFwdBckFilteredViewingLeads(null) )
    }
    if (mortgage.notifCount && mortgage.notifCount > 0) {
      dispatch( removeNotificationFromMortgage({mortgageId: mortgage._id}) )
    }
    if (destination === 'investigateLead') {
      dispatch( setMortgageActionNavMenuSelection('investigateLead') )
    } else if (destination === 'provideTerms') {
      dispatch( setMortgageActionNavMenuSelection('provideTerms') )
    } else {
      dispatch( setMortgageActionNavMenuSelection('compareRecords') )
    }
    if (mortgagesFilteredBoolean) {
      dispatch( setFwdBckViewingFilteredMortgages(mortgage._id) )
    } else {
      dispatch( setFwdBckViewingMortgages(mortgage._id) )
    }
    dispatch( setViewingMortgage(mortgage) )
    dispatch( setShowMortgageActionsModal(true) )
    navigate(`/dashboard/mortgageRepository/${mortgage._id}`)
  }
  const handleCloseModal = () => {
    navigate(`/dashboard/mortgageRepository/`)
    dispatch( setViewingFromSearchBool(false) )
    dispatch( setViewingMortgageActions(false) )
    dispatch( setShowMortgageActionsModal(false) )
  }
  const handleOpenUploadModal = () => {
    dispatch( setViewingUploadWindow(true) )
  }
  const handleCloseUploadModal = () => {
    if (!runningSweep) {
      dispatch( setViewingUploadWindow(false) )
    }
  }
 
  const handleUserChange = async (event) => {
    if (event === 'team') {
      setUserFilter('team')
      setMortgageRows(teamMortgages)
      dispatch( setMortgagesFilteredBoolean(false) )
      dispatch( setFilteredMortgages(null) )
    } else {
      setUserFilter(event)
      let filteredMortgages = await handleFilterMortgages('user', teamMortgages, event, null)
      dispatch( setMortgagesFilteredBoolean(true) )
      setMortgageRows(filteredMortgages)
      dispatch( setFilteredMortgages(filteredMortgages) )
    }
  }

  const [matchTypeSelection, setMatchTypeSelection] = useState('all')
  const handleMatchTypeSelection = (event) => {
    let newSelection = 'all'
    if (event.target.value === 'any') {
      newSelection = 'any'
    }
    setMatchTypeSelection(event.target.value)
    if (displaySelection === 'Table View') {
      handleSelectedTableDetails({target: {value: selectedTableDetail, selection: newSelection}})
    } else {
      handleSelectedTableDetails({target: {value: customTagCombination, selection: newSelection}})
    }
  }

  const [tagTypesForDropdown, setTagTypesForDropdown] = useState(tagsViewMortgages ? tagsViewMortgages.map(view => {
    return {
      tagType: view.tagType,
      tagTypeAbbr: view.tagTypeAbbr,
      customTagView: view.customTagView
    }
  }) : [])
  const [selectedTableDetail, setSelectedTableDetail] = useState(['all'])
  const [customTagCombination, setCustomTagCombination] = useState([])
  const handleSelectedTableDetails = async (event) => {
    let newSelectedDetails = event.target.value
    let tableSelectionReset = false
    let thisMatchTypeSelection = matchTypeSelection
    if (event.target.selection) {
      thisMatchTypeSelection = event.target.selection
    }
    if (displaySelection === 'Table View') {
      if ((newSelectedDetails[0] === 'all' && newSelectedDetails.length === 1) || (newSelectedDetails[newSelectedDetails.length-1] === 'all' && newSelectedDetails[0] !== 'all') || newSelectedDetails.length === 0) {
        setMortgageRows(teamMortgages)
        dispatch( setMortgagesFilteredBoolean(false) )
        dispatch( setFilteredMortgages(null) )
        setSelectedTableDetail(['all'])
        setCustomTagCombination([])
        tableSelectionReset = true
        newSelectedDetails = ['all']
      } else {
        let allIndex = newSelectedDetails.indexOf('all')
        if (allIndex >= 0) {
          newSelectedDetails.splice(allIndex, 1)
        }
        let customIndex = newSelectedDetails.indexOf('Custom')
        if (customIndex >= 0) {
          newSelectedDetails.splice(customIndex, 1)
        }
        setSelectedTableDetail(newSelectedDetails)
        setCustomTagCombination(newSelectedDetails)
      }
    } else if (newSelectedDetails.length === 0) {
      setMortgageRows(teamMortgages)
      dispatch( setMortgagesFilteredBoolean(false) )
      dispatch( setFilteredMortgages(null) )
      setSelectedTableDetail(['all'])
      setCustomTagCombination([])
      tableSelectionReset = true
      newSelectedDetails = []
    }
    let newCustomTagCombinationMortgageIds = []
    if (thisMatchTypeSelection === 'any') {
      for (let i = 0; i < newSelectedDetails.length; i++) {
        let matchingTagView = tagsViewMortgages.find(view => view.tagType === newSelectedDetails[i])
        if (matchingTagView) {
          for (let j = 0; j < matchingTagView.mortgages.length; j++) {
            let matchingMortgage = newCustomTagCombinationMortgageIds.find(mortgageId => mortgageId === matchingTagView.mortgages[j])
            if (!matchingMortgage) {
              newCustomTagCombinationMortgageIds.push(matchingTagView.mortgages[j])
            }
          }
        }
      }
    } else if (thisMatchTypeSelection === 'none') {
      newCustomTagCombinationMortgageIds = teamMortgages.map(item => item._id)
      for (let i = 0; i < newSelectedDetails.length; i++) {
        let matchingTagView = tagsViewMortgages.find(view => view.tagType === newSelectedDetails[i])
        if (matchingTagView) {
          for (let j = 0; j < matchingTagView.mortgages.length; j++) {
            let matchingMortgage = newCustomTagCombinationMortgageIds.find(mortgageId => mortgageId === matchingTagView.mortgages[j])
            if (matchingMortgage) {
              let thisIndex = newCustomTagCombinationMortgageIds.indexOf(matchingMortgage)
              newCustomTagCombinationMortgageIds.splice(thisIndex, 1)
            }
          }
        }
      }
    } else {
      let matchingViews = []
      for (let i = 0; i < newSelectedDetails.length; i++) {
        let matchingTagView = tagsViewMortgages.find(view => view.tagType === newSelectedDetails[i])
        if (matchingTagView) {
          matchingViews.push(matchingTagView)
        }
      }
      if (matchingViews.length === 1) {
        newCustomTagCombinationMortgageIds = matchingViews[0].mortgages
      } else if (matchingViews.length > 0) {
        for (let j = 0; j < matchingViews[0].mortgages.length; j++) {
          let existsInAll = true
          for (let k = 1; k < matchingViews.length; k++) {
            if (!matchingViews[k].mortgages.includes(matchingViews[0].mortgages[j])) {
              existsInAll = false
              break
            }
          }
          if (existsInAll) {
            newCustomTagCombinationMortgageIds.push(matchingViews[0].mortgages[j])
          }
        }
      }
    }
    let filteredMortgages = []
    if (displaySelection === 'Table View') {
      if (!tableSelectionReset) {
        filteredMortgages = await handleFilterMortgages('customTagViewCombination', teamMortgages, null, newCustomTagCombinationMortgageIds)
        dispatch( setMortgagesFilteredBoolean(true) )
        setMortgageRows(filteredMortgages)
        dispatch( setFilteredMortgages(filteredMortgages) )
      }
    } else {
      if (!tableSelectionReset) {
        setSelectedTableDetail(newSelectedDetails)
        if (matchTypeSelection === 'none') {
          setCustomTagCombination(event.target.value)
        } else {
          setCustomTagCombination(newSelectedDetails)
        }
        filteredMortgages = await handleFilterMortgages('customTagViewCombination', teamMortgages, null, newCustomTagCombinationMortgageIds)
        dispatch( setMortgagesFilteredBoolean(true) )
        setMortgageRows(filteredMortgages)
        dispatch( setFilteredMortgages(filteredMortgages) )
      }
    }
    if (filteredMortgages.length > 0) {
      if (!customTagViewAdded) {
        dispatch( addCustomTagView({
          tagType: 'Custom',
          tagTypeAbbr: 'Custom',
          customTagView: true,
          totalMortgages: filteredMortgages.length,
          mortgages: null,
        }) )
      } else {
        dispatch( editCustomTagView({
          newTotal: filteredMortgages.length,
        }))
      }
    } else if (customTagViewAdded && newSelectedDetails.length === 0 && displaySelection === 'Chart View') {
      setMortgageRows(teamMortgages)
      dispatch( setMortgagesFilteredBoolean(false) )
      dispatch( setFilteredMortgages(null) )
      dispatch( removeCustomTagView())
    } else if (customTagViewAdded) {
      dispatch( editCustomTagView({
        newTotal: 0,
      }))
    }
  }

  const [displaySelection, setDisplaySelection] = useState('Table View')
  const handleDisplayChange = (event) => {
    setDisplaySelection(event.target.value)
  }

  useEffect(() => {
    setMortgageRows(teamMortgages)
    if (viewingMortgageActions) {
      dispatch( setShowMortgageActionsModal(true) )
    }
  }, [teamMortgages, viewingMortgageActions, dispatch])

  const repositoryTooltipProps = {
    tooltip: {sx: {
      color: `${theme.palette.common.white}`,
      backgroundColor: `${theme.palette.common.black}`,
      fontSize: "0.85rem",
      fontWeight: "700",
      letterSpacing: "0",
      margin: '0',
      borderRadius: "0.45rem",
      padding: "0.45rem 0.65rem",
    }}
  }

  const repositoryTooltipPopperProps = {modifiers: [{
    name: "offset",
    options: {
      offset: [0, 0],
    },
  }]}

  const renderAssignmentLabel = (cellValues) => {
    return (
      <Tooltip
        componentsProps={repositoryTooltipProps}
        PopperProps={repositoryTooltipPopperProps}
        title="Open Actions Window"
        placement="right"
        arrow
      >
        {cellValues.row.newAssignmentNotification ?
          <RepositoryPill $tone="new" onClick={() => handleOpenActionModal(cellValues.row)}>
            New Assignment
          </RepositoryPill>
        : cellValues.row.userAssignment ?
          <RepositoryPill $tone="assigned" onClick={() => handleOpenActionModal(cellValues.row)}>
            Assigned
          </RepositoryPill>
        : cellValues.row.notifCount && cellValues.row.notifCount !== 0 ?
          <RepositoryPill $tone="updates" onClick={() => handleOpenActionModal(cellValues.row)}>
            Updates
          </RepositoryPill>
        :
          <></>
        }
      </Tooltip>
    )
  }
  const renderFinancialsButton = (cellValues) => {
    return (
      <CellCenter>
        <Tooltip
          componentsProps={repositoryTooltipProps}
          PopperProps={repositoryTooltipPopperProps}
          title={!cellValues.row.financialsPresent ? "Provide financials" : "Financials present"}
          placement="left"
          arrow
        >
          <RepositoryCellAction
            $tone={!cellValues.row.financialsPresent ? "warning" : "neutral"}
            onClick={() => handleOpenActionModal(cellValues.row, 'provideTerms')}
          >
            {!cellValues.row.financialsPresent ?
              <>
                <MoneyOffIcon />
                missing
              </>
            :
              <>
                <AttachMoneyIcon />
                present
              </>
            }
          </RepositoryCellAction>
        </Tooltip>
      </CellCenter>
    )
  }
  const renderActionButtons = (cellValues) => {
    return (
      <CellCenter>
        <Tooltip
          componentsProps={repositoryTooltipProps}
          PopperProps={repositoryTooltipPopperProps}
          title="Open Actions Window"
          placement="right"
          arrow
        >
          <RepositoryIconButton onClick={() => handleOpenActionModal(cellValues.row)}>
            <NotificationIconGroup>
              {(cellValues.row.notifCount && cellValues.row.notifCount !== 0) ?
                <>
                  <NotificationsIcon className="active" />
                  <RepositoryBadge>
                    {cellValues.row.notifCount}
                  </RepositoryBadge>
                </>
              : cellValues.row.newAssignmentNotification ?
                <NotificationsIcon className="inactive" />
              :
                <NotificationsNoneIcon className="outlined" />
              }
            </NotificationIconGroup>
            <OpenInNewIcon className="openIcon" />
          </RepositoryIconButton>
        </Tooltip>
      </CellCenter>
    )
  }
  const renderStatusButton = (cellValues) => {
    return (
      <CellCenter>
        <Tooltip
          componentsProps={repositoryTooltipProps}
          PopperProps={repositoryTooltipPopperProps}
          title={cellValues.row.status === 'inactive' ?
            "Inactive"
          : cellValues.row.status === 'awaitingAction' ?
            "currently Awaiting Action"
          : cellValues.row.status === 'investigating' ?
            "currently Under Investigation"
          : cellValues.row.status === 'awaitingUpdate' && cellValues.row.publicRecordsUpdated ?
            "Public Records were updated. Please review new arrangements."
          : cellValues.row.status === 'awaitingUpdate' && cellValues.row.awaitingUpdates ?
            "Awaiting Public Records to reflect expected arrangements."
          : cellValues.row.status === 'awaitingUpdate' ?
            "Awaiting confirmation that Public Records reflect the expected arrangements."
          :
            "currently Closing the Investigation"
          } 
          placement="left"
          arrow
        >
          {cellValues.row.status === 'inactive' ?
            <RepositoryStatusChip $tone="inactive" onClick={() => handleOpenActionModal(cellValues.row, 'investigateLead')}>
              <RadioButtonUncheckedIcon />
            </RepositoryStatusChip>
          : cellValues.row.status === 'awaitingAction' ?
            <RepositoryStatusChip $tone="active">
              <RadioButtonUncheckedIcon />
              <ArrowForwardIcon className="secondaryIcon" />
            </RepositoryStatusChip>
          : cellValues.row.status === 'investigating' ?
            <RepositoryStatusChip $tone="active">
              <RadioButtonCheckedIcon />
            </RepositoryStatusChip>
          : cellValues.row.status === 'awaitingUpdate' && cellValues.row.publicRecordsUpdated ?
            <RepositoryStatusChip $tone="active">
              <CheckCircleOutlineIcon />
            </RepositoryStatusChip>
          : cellValues.row.status === 'awaitingUpdate' && cellValues.row.awaitingUpdates ?
            <RepositoryStatusChip $tone="active">
              <PendingIcon />
            </RepositoryStatusChip>
          : cellValues.row.status === 'awaitingUpdate' ?
            <RepositoryStatusChip $tone="active">
              <TaskAltIcon />
            </RepositoryStatusChip>
          :
            <RepositoryStatusChip $tone="active">
              <CircleIcon />
            </RepositoryStatusChip>
          }
        </Tooltip>
      </CellCenter>
    )
  }

  const columns = [
    {
      field: 'id' , 
      headerName: '', 
      renderCell: renderAssignmentLabel,
      disableClickEventBubbling: true,
      width: 100,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 50,
      renderCell: renderActionButtons,
      disableClickEventBubbling: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'financialsPresent',
      headerName: 'Financials',
      width: 70,
      renderCell: renderFinancialsButton,
      disableClickEventBubbling: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 50,
      renderCell: renderStatusButton,
      disableClickEventBubbling: true,
      headerAlign: 'center',
      align: 'center',
    },
    {field: "propertyType", headerName: "Property Type", width: 90},
    {field: "streetAddress", headerName: "Street Address", width: 200},
    {field: "city", headerName: "City", width: 130},
    {field: "originationDateLabel", headerName: "Origination Date", width: 90},
    {field: "monthsRemaining", headerName: "Months Remaining", align: 'center', width: 100},
    {field: "owner1", headerName: "Primary Owner", width: 190},
    {field: "owner2", headerName: "Co-Owner", width: 190},
  ]

  return (
    <>
      <MortgageRepositoryPage>
        <MortgageRepositoryWorkspace>
          <WorkspaceHeader>
            <HeaderCopy>
              <WorkspaceEyebrow>Mortgage Repository</WorkspaceEyebrow>
              <WorkspaceTitle>Mortgage Repository</WorkspaceTitle>
              <WorkspaceSummary>
                Search, filter, review, and manage uploaded mortgage records, investigation progress, financial readiness, and operational status.
              </WorkspaceSummary>
            </HeaderCopy>
            <HeaderMetric>
              <span>{mortgageRows.length}</span>
              displayed records
            </HeaderMetric>
          </WorkspaceHeader>

          <RepositoryBody>
            <RepositoryControlsPanel>
              <RepositoryControls matchTypeSelection={matchTypeSelection} tagTypesForDropdown={tagTypesForDropdown} handleSelectedTableDetails={handleSelectedTableDetails} customTagCombination={customTagCombination} tagsViewMortgages={tagsViewMortgages} handleUserChange={handleUserChange} selectedTableDetail={selectedTableDetail} userFilter={userFilter} displaySelection={displaySelection} handleDisplayChange={handleDisplayChange} handleMatchTypeSelection={handleMatchTypeSelection} handleOpenUploadModal={handleOpenUploadModal} />
            </RepositoryControlsPanel>
            <RepositoryContentSurface>
            {mortgageRows.length === 0 ?
              <RepositoryEmptyState>
                <DomainDisabledIcon />
                <EmptyStateTitle>
                  {teamMortgages.length === 0 ? `no mortgages have been uploaded` : `no mortgages match the selected criteria`}
                </EmptyStateTitle>
              </RepositoryEmptyState>
            : mortgageRows !== undefined && displaySelection === 'Table View' ?
              <TableViewport>
              <StripedDataGrid
                sx={repositoryDataGridSx}
                rows={mortgageRows}
                rowHeight={40}
                columns={columns}
                getRowId={(row) =>  row._id}
                components={{
                  Toolbar: GridToolbar,
                }}
                getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => dispatch( setRepositoryPageSize(newPageSize))}
                rowsPerPageOptions={[20, 40, 80]}
                page={currentPageSize}
                onPageChange={(newPage) => dispatch( setRepositoryPage(newPage) )}
                pagination
              />
              </TableViewport>
            : displaySelection === 'Chart View' ?
              <ChartViewport>
                <TagsView displaySelection={displaySelection} tagsViewMortgages={tagsViewMortgages} />
              </ChartViewport>
            :
              <RepositoryLoadingState>
                <CircularProgress
                  sx={{ color: `${theme.palette.primary.main}`}}
                  size={48}
                />
              </RepositoryLoadingState>
            }
            </RepositoryContentSurface>
          </RepositoryBody>
        </MortgageRepositoryWorkspace>
      </MortgageRepositoryPage>

      <Dialog open={showMortgageActionsModal} onClose={handleCloseModal} 
        PaperProps={{ sx: {width: "95%", minWidth: "100rem", maxWidth: "150rem", height: "fit-content", minHeight: "66rem", maxHeight: "95%"}}}
        tabIndex={-1}
      >
        <MortgageActionsModal handleCloseModal={handleCloseModal} userId={userId} teamId={teamId} userFullName={userFullName} dashPerspective={dashPerspective} />
      </Dialog>
      <Dialog open={showUploadModal} onClose={handleCloseUploadModal}
        PaperProps={{ sx: {width: "130rem", minWidth: "130rem", maxWidth: "130rem", height: "63rem", minHeight: "63rem", maxHeight: "63rem"}}}
        tabIndex={-1}
      >
        <UploadModal handleCloseModal={handleCloseUploadModal} userFullName={userFullName} teamId={teamId} />
      </Dialog>
    </>
  )
}

const repositoryDataGridSx = (theme) => ({
  border: 0,
  width: "100%",
  height: "100%",
  minWidth: "64rem",
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black,
  fontFamily: "inherit",
  "& .MuiSvgIcon-root": {
    color: "inherit",
  },
  "& .MuiDataGrid-main": {
    minHeight: 0,
    minWidth: 0,
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: theme.palette.common.grayBorderLight,
    borderBottom: `0.1rem solid ${theme.palette.common.grayBorderMedium}`,
    minHeight: "3.4rem !important",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 0.75rem",
    outline: "none !important",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    color: theme.palette.common.grayDark,
    fontSize: "0.72rem",
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1.2,
    textTransform: "uppercase",
    whiteSpace: "normal",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
    color: theme.palette.common.blackLight,
    fontSize: "0.82rem",
    fontWeight: 600,
    lineHeight: 1.35,
    padding: "0 0.75rem",
    outline: "none !important",
  },
  "& .MuiDataGrid-cellContent": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiDataGrid-row": {
    backgroundColor: theme.palette.common.white,
  },
  "& .MuiDataGrid-row.even": {
    backgroundColor: theme.palette.common.pageBackground,
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: theme.palette.common.grayBorderLight,
  },
  "& .MuiDataGrid-toolbarContainer": {
    minHeight: "3rem",
    padding: "0.4rem 0.7rem",
    borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
    backgroundColor: theme.palette.common.white,
    gap: "0.35rem",
  },
  "& .MuiDataGrid-toolbarContainer .MuiButton-root": {
    color: theme.palette.primary.dark,
    borderRadius: "0.45rem",
    fontSize: "0.72rem",
    fontWeight: 800,
    letterSpacing: 0,
    padding: "0.35rem 0.55rem",
    textTransform: "none",
  },
  "& .MuiDataGrid-toolbarContainer .MuiButton-root:hover": {
    backgroundColor: theme.palette.primary.labelTransparent,
  },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "auto",
    backgroundColor: theme.palette.common.white,
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
    width: "0.4rem",
    height: "0.4rem",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
    background: theme.palette.common.white,
    border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
    background: theme.palette.common.grayBorderDark,
    borderRadius: "999px",
  },
  "& .MuiDataGrid-footerContainer": {
    minHeight: "3.2rem",
    borderTop: `0.1rem solid ${theme.palette.common.grayBorder}`,
    backgroundColor: theme.palette.common.white,
  },
  "& .MuiTablePagination-root": {
    color: theme.palette.common.grayDark,
    fontSize: "0.82rem",
    fontWeight: 700,
  },
  "& .MuiTablePagination-select": {
    color: theme.palette.primary.dark,
    fontWeight: 800,
  },
  "& .MuiTablePagination-actions .MuiIconButton-root": {
    color: theme.palette.primary.dark,
  },
})

const MortgageRepositoryPage = styled("section")(({ theme }) => ({
  width: "100%",
  height: "100%",
  minHeight: 0,
  padding: "1rem",
  background: theme.palette.common.pageBackground,
  overflow: "hidden",
}))

const MortgageRepositoryWorkspace = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  minHeight: 0,
  display: "grid",
  gridTemplateRows: "auto minmax(0, 1fr)",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.65rem",
  background: theme.palette.common.white,
  boxShadow: "0 1rem 2.5rem rgba(28, 28, 31, 0.06)",
  overflow: "hidden",
}))

const WorkspaceHeader = styled("header")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "1rem",
  padding: "1.1rem 1.25rem",
  borderBottom: `0.1rem solid ${theme.palette.common.grayBorder}`,
  background: theme.palette.common.white,
}))

const HeaderCopy = styled("div")({
  minWidth: 0,
})

const WorkspaceEyebrow = styled("div")(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: "0.72rem",
  fontWeight: 900,
  letterSpacing: 0,
  lineHeight: 1,
  marginBottom: "0.35rem",
  textTransform: "uppercase",
}))

const WorkspaceTitle = styled("h1")(({ theme }) => ({
  margin: 0,
  color: theme.palette.common.black,
  fontSize: "1.55rem",
  fontWeight: 900,
  letterSpacing: 0,
  lineHeight: 1.1,
}))

const WorkspaceSummary = styled("p")(({ theme }) => ({
  margin: "0.35rem 0 0",
  color: theme.palette.common.grayText,
  fontSize: "0.88rem",
  fontWeight: 600,
  lineHeight: 1.4,
}))

const HeaderMetric = styled("div")(({ theme }) => ({
  flex: "0 0 auto",
  display: "grid",
  gap: "0.15rem",
  justifyItems: "end",
  color: theme.palette.common.grayDark,
  fontSize: "0.72rem",
  fontWeight: 800,
  letterSpacing: 0,
  textTransform: "uppercase",
  "& span": {
    color: theme.palette.common.black,
    fontSize: "1.35rem",
    fontWeight: 900,
    lineHeight: 1,
  },
}))

const RepositoryBody = styled("div")(({ theme }) => ({
  minHeight: 0,
  display: "grid",
  gridTemplateRows: "auto minmax(0, 1fr)",
  gap: "0.85rem",
  padding: "0.85rem",
  background: theme.palette.common.grayBorderLight,
  overflow: "hidden",
}))

const RepositoryControlsPanel = styled("section")(({ theme }) => ({
  minWidth: 0,
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.55rem",
  background: theme.palette.common.white,
  boxShadow: "0 0.45rem 1.4rem rgba(28, 28, 31, 0.04)",
  overflowX: "hidden",
  overflowY: "hidden",
}))

const RepositoryContentSurface = styled("section")(({ theme }) => ({
  minHeight: 0,
  minWidth: 0,
  display: "grid",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.55rem",
  background: theme.palette.common.white,
  overflow: "hidden",
  boxShadow: "0 0.45rem 1.4rem rgba(28, 28, 31, 0.04)",
}))

const TableViewport = styled("div")({
  minHeight: 0,
  minWidth: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden",
})

const ChartViewport = styled("div")({
  minHeight: 0,
  minWidth: 0,
  width: "100%",
  height: "100%",
  display: "grid",
  placeItems: "stretch",
  padding: "1rem",
})

const RepositoryEmptyState = styled("div")(({ theme }) => ({
  minHeight: 0,
  display: "grid",
  alignContent: "center",
  justifyItems: "center",
  gap: "0.75rem",
  padding: "2rem",
  color: theme.palette.common.grayText,
  "& svg": {
    width: "4.8rem",
    height: "4.8rem",
    color: theme.palette.common.grayBorderDark,
  },
}))

const EmptyStateTitle = styled("div")(({ theme }) => ({
  color: theme.palette.common.grayDark,
  fontSize: "1rem",
  fontWeight: 800,
  letterSpacing: 0,
  textAlign: "center",
}))

const RepositoryLoadingState = styled("div")({
  display: "grid",
  placeItems: "center",
  minHeight: 0,
})

const CellCenter = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 0,
})

const RepositoryPill = styled("button")(({ theme, $tone }) => {
  const tones = {
    new: {
      color: theme.palette.primary.dark,
      border: theme.palette.primary.pastelMedium,
      background: theme.palette.primary.labelTransparent,
    },
    assigned: {
      color: theme.palette.primary.dark,
      border: theme.palette.primary.pastelMedium,
      background: theme.palette.primary.labelTransparent,
    },
    updates: {
      color: theme.palette.common.orangeDark,
      border: theme.palette.common.orange,
      background: theme.palette.common.orangeTransparent,
    },
  }
  const tone = tones[$tone] || tones.assigned

  return {
    maxWidth: "100%",
    border: `0.1rem solid ${tone.border}`,
    borderRadius: "999px",
    background: tone.background,
    color: tone.color,
    cursor: "pointer",
    font: "inherit",
    fontSize: "0.72rem",
    fontWeight: 900,
    letterSpacing: 0,
    lineHeight: 1,
    padding: "0.32rem 0.55rem",
    whiteSpace: "nowrap",
    transition: "background 140ms ease, border-color 140ms ease, box-shadow 140ms ease",
    "&:hover": {
      boxShadow: "0 0.35rem 0.75rem rgba(28, 28, 31, 0.08)",
    },
    "&:focus-visible": {
      outline: `0.15rem solid ${theme.palette.primary.transparentMid}`,
      outlineOffset: "0.1rem",
    },
  }
})

const RepositoryCellAction = styled("button")(({ theme, $tone }) => ({
  height: "2rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.3rem",
  border: `0.1rem solid ${$tone === "warning" ? theme.palette.common.orangeMediumTransparentHover : theme.palette.common.grayBorder}`,
  borderRadius: "0.45rem",
  background: $tone === "warning" ? theme.palette.common.orangeTransparent : theme.palette.common.white,
  color: $tone === "warning" ? theme.palette.common.orangeDark : theme.palette.common.grayDark,
  cursor: "pointer",
  font: "inherit",
  fontSize: "0.72rem",
  fontWeight: 900,
  letterSpacing: 0,
  padding: "0 0.5rem",
  textTransform: "lowercase",
  whiteSpace: "nowrap",
  transition: "background 140ms ease, border-color 140ms ease, box-shadow 140ms ease",
  "& svg": {
    width: "1rem",
    height: "1rem",
  },
  "&:hover": {
    background: $tone === "warning" ? theme.palette.common.orangeTransparentHover : theme.palette.common.grayHover,
    boxShadow: "0 0.35rem 0.75rem rgba(28, 28, 31, 0.08)",
  },
  "&:focus-visible": {
    outline: `0.15rem solid ${theme.palette.primary.transparentMid}`,
    outlineOffset: "0.1rem",
  },
}))

const RepositoryIconButton = styled("button")(({ theme }) => ({
  height: "2rem",
  minWidth: "4.8rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.45rem",
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  borderRadius: "0.45rem",
  background: theme.palette.common.white,
  cursor: "pointer",
  padding: "0 0.45rem",
  position: "relative",
  transition: "background 140ms ease, border-color 140ms ease, box-shadow 140ms ease",
  "& svg": {
    width: "1.1rem",
    height: "1.1rem",
  },
  "& .active": {
    color: theme.notification.color.active,
  },
  "& .inactive": {
    color: theme.notification.color.inactive,
  },
  "& .outlined": {
    color: theme.notification.color.outlined,
  },
  "& .openIcon": {
    color: theme.palette.primary.dark,
  },
  "&:hover": {
    background: theme.palette.primary.labelTransparent,
    borderColor: theme.palette.primary.pastelMedium,
    boxShadow: "0 0.35rem 0.75rem rgba(28, 28, 31, 0.08)",
  },
  "&:focus-visible": {
    outline: `0.15rem solid ${theme.palette.primary.transparentMid}`,
    outlineOffset: "0.1rem",
  },
}))

const NotificationIconGroup = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  width: "1.3rem",
  height: "1.3rem",
})

const RepositoryBadge = styled("span")(({ theme }) => ({
  minWidth: "1rem",
  height: "1rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  top: "-0.45rem",
  right: "-0.55rem",
  border: `0.1rem solid ${theme.palette.common.white}`,
  borderRadius: "999px",
  background: theme.notification.background.active,
  color: theme.palette.common.white,
  fontSize: "0.62rem",
  fontWeight: 900,
  lineHeight: 1,
  padding: "0 0.18rem",
}))

const RepositoryStatusChip = styled("div")(({ theme, $tone, onClick }) => ({
  minWidth: "2rem",
  height: "2rem",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.15rem",
  border: `0.1rem solid ${$tone === "inactive" ? theme.palette.common.grayBorder : theme.palette.primary.pastelMedium}`,
  borderRadius: "0.45rem",
  background: $tone === "inactive" ? theme.palette.common.white : theme.palette.primary.labelTransparent,
  color: $tone === "inactive" ? theme.palette.common.grayBorderDark : theme.palette.primary.dark,
  cursor: onClick ? "pointer" : "default",
  padding: "0 0.35rem",
  transition: "background 140ms ease, border-color 140ms ease, box-shadow 140ms ease",
  "& svg": {
    width: "1.1rem",
    height: "1.1rem",
    color: "inherit",
  },
  "& .secondaryIcon": {
    width: "0.85rem",
    height: "0.85rem",
    color: theme.palette.secondary.main,
  },
  "&:hover": onClick ? {
    background: theme.palette.primary.labelTransparent,
    borderColor: theme.palette.primary.pastelMedium,
    boxShadow: "0 0.35rem 0.75rem rgba(28, 28, 31, 0.08)",
  } : undefined,
}))

export default MortgageRepository;
